export default "__VITE_ASSET__D8Zg0MKu__"